import type { QueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';

export const invalidateGroupCachesForPerson = (
  queryClient: QueryClient,
  // oxlint-disable-next-line @typescript-eslint/no-unused-vars
  _personId: string
) => {
  queryClient.invalidateQueries({
    queryKey: [API_CACHE_KEYS.GROUP_MEMBERS]
  });
  queryClient.invalidateQueries({
    queryKey: [API_CACHE_KEYS.GROUP_ADMINS]
  });
};
